import { render, staticRenderFns } from "./available-projects.vue?vue&type=template&id=7707b583&scoped=true&"
import script from "./available-projects.vue?vue&type=script&lang=ts&"
export * from "./available-projects.vue?vue&type=script&lang=ts&"
import style0 from "./available-projects.vue?vue&type=style&index=0&id=7707b583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7707b583",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
